export const Search = () => (
  <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M31.6672 30.048L22.2272 20.6144C24.0448 18.432 25.1392 15.6288 25.1392 12.576C25.1456 5.6384 19.5008 0 12.5696 0C5.6384 0 0 5.6384 0 12.5696C0 19.5008 5.6384 25.1392 12.5696 25.1392C15.6224 25.1392 18.4256 24.0448 20.608 22.2272L30.048 31.6672C30.272 31.8912 30.5664 32 30.8544 32C31.1424 32 31.4368 31.8912 31.6608 31.6672C32.1088 31.2192 32.1088 30.496 31.6672 30.048ZM2.2848 12.5696C2.2848 6.8992 6.8992 2.2848 12.5696 2.2848C18.24 2.2848 22.8544 6.8992 22.8544 12.5696C22.8544 18.24 18.24 22.8544 12.5696 22.8544C6.8992 22.8544 2.2848 18.24 2.2848 12.5696Z"
      fill="#0019A5"
    />
  </svg>
);
